import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { MOBILE_BREAK_POINT } from 'Defaults'

import {
  MobileSearchExtraFilters,
  MobileSearchMainFilters,
  MobileSearchMarketReport,
  MobileDiscoveryAreas,
} from '../index'

import { MobileSchoolFilters } from '../MobileSchoolFilters'
import { checkSchoolFiltersInSearchParams } from '../../../../../utils/schoolUtils'

const MobileContainer = (
  {
    winWidth,
    googleAnalyticsEvent,
    analyticsButtonActive,
    setAnalyticsButtonState,
    setMobileFilterButtonState,
    filterButtonActive,
    dockIsOpen,
    pagination,
    isDiscoveryAreaOpen,
    offer,
    isArchive,
    isSchoolFilterOpen,
    searchObj,
    lastSearchObj,
    setMobileSchoolFilterState,
    isMobileApp,
  },
) => {
  const schoolEnabled = !!checkSchoolFiltersInSearchParams(lastSearchObj)

  if(winWidth && winWidth <= MOBILE_BREAK_POINT) {
    return (
      <Fragment>
        <MobileSearchMainFilters offer={offer} dockIsOpen={dockIsOpen} />

        {
          isDiscoveryAreaOpen && (
            <MobileDiscoveryAreas
              isArchive={isArchive}
              googleAnalyticsEvent={googleAnalyticsEvent}
              pagination={pagination}
            />
          )
        }
        {
          analyticsButtonActive && (
            <MobileSearchMarketReport
              setAnalyticsButtonState={setAnalyticsButtonState}
            />
          )
        }

        {
          filterButtonActive && (
            <MobileSearchExtraFilters
              smallerThan767={winWidth < MOBILE_BREAK_POINT}
              offer={offer}
              pagination={pagination}
              toggleMobileFilter={setMobileFilterButtonState}
              filterButtonActive={filterButtonActive}
              isArchive={isArchive}
            />
          )
        }
        {
          isSchoolFilterOpen && (
            <MobileSchoolFilters
              toggleMobileFilter={setMobileSchoolFilterState}
              filterButtonActive={isSchoolFilterOpen}
              googleAnalyticsEvent={googleAnalyticsEvent}
              schoolLevel={searchObj.school_level}
              schoolType={searchObj.school_type}
              schoolLanguage={searchObj.school_language}
              schoolEnabled={schoolEnabled}
              searchObj={searchObj}
              isMobileApp={isMobileApp}
            />
          )
        }
      </Fragment>
    )
  }

  return null
}
MobileContainer.propTypes = {
  winWidth: PropTypes.number,
  googleAnalyticsEvent: PropTypes.func,
  analyticsButtonActive: PropTypes.bool,
  setAnalyticsButtonState: PropTypes.func,
  setMobileFilterButtonState: PropTypes.func,
  filterButtonActive: PropTypes.bool,
  dockIsOpen: PropTypes.bool,
  offer: PropTypes.string,
  isDiscoveryAreaOpen: PropTypes.bool,
  isArchive: PropTypes.bool,
  pagination: PropTypes.shape({
    total: PropTypes.number,
    perPage: PropTypes.number,
    currentPage: PropTypes.number,
  }),
  searchObj: PropTypes.shape(({
    school_level: PropTypes.string,
    school_type: PropTypes.string,
    school_language: PropTypes.string,
  })),
  isMobileApp: PropTypes.bool,
  setMobileSchoolFilterState: PropTypes.func,
  lastSearchObj: PropTypes.shape({}),
  isSchoolFilterOpen: PropTypes.bool,
}
export default MobileContainer
